// Category Card Component for Homepage
import { Link } from 'react-router-dom';
import { Card, CardContent } from '@/components/ui/card';

const CategoryCard = ({ category, size = 'default' }) => {
  const Icon = category.icon;
  
  if (size === 'small') {
    return (
      <Link 
        to={`/products?category=${category.id}`}
        className="group"
        data-testid={`category-card-${category.id.toLowerCase()}`}
      >
        <div className="flex flex-col items-center gap-2 p-3 rounded-xl transition-all hover:scale-105">
          <div className={`w-12 h-12 rounded-full ${category.lightColor} ${category.textColor} flex items-center justify-center group-hover:scale-110 transition-transform`}>
            <Icon className="w-6 h-6" />
          </div>
          <span className="text-xs font-medium text-center">{category.name}</span>
        </div>
      </Link>
    );
  }
  
  return (
    <Link 
      to={`/products?category=${category.id}`}
      className="group"
      data-testid={`category-card-${category.id.toLowerCase()}`}
    >
      <Card className="overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1 border-2 border-transparent hover:border-primary/20">
        <CardContent className="p-6">
          <div className="flex items-start gap-4">
            <div className={`w-14 h-14 rounded-xl ${category.color} text-white flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
              <Icon className="w-7 h-7" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-lg group-hover:text-primary transition-colors" style={{ fontFamily: 'Archivo, sans-serif' }}>
                {category.name}
              </h3>
              <p className="text-sm text-muted-foreground mt-1">
                {category.description}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};

export default CategoryCard;
